import { useEffect } from 'react';
import { UiContainer } from '../../state/ui';

export function ScrollPreventer() {
	const ui = UiContainer.useContainer();
	const isScrollingPrevented = ui.isScrollingPrevented;

	useEffect(() => {
		// Adjust client width to removed scrollbar in order to avoid CLS when an overlay opens.
		const { clientWidth } = document.body;
		if (isScrollingPrevented) {
			document.body.style.overflowY = 'hidden';
			document.body.style.width = `${clientWidth}px`;
		} else {
			document.body.style.overflowY = 'scroll';
			document.body.style.width = '';
		}
	}, [isScrollingPrevented]);

	return null;
}
